const cueSet2 = [
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 491520,
        "time": 21.333312,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 499200,
        "time": 21.666645,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 506880,
        "time": 21.999978,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 518400,
        "time": 22.4999775,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 522240,
        "time": 22.666643999999998,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 529920,
        "time": 22.999976999999998,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 533760,
        "time": 23.1666435,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 537600,
        "time": 23.33331,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 549120,
        "time": 23.8333095,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 552960,
        "time": 23.999976,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 560640,
        "time": 24.333309,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 568320,
        "time": 24.666642,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 579840,
        "time": 25.1666415,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 583680,
        "time": 25.333308,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 587520,
        "time": 25.4999745,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 591360,
        "time": 25.666641,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 599040,
        "time": 25.999973999999998,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 610560,
        "time": 26.4999735,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 614400,
        "time": 26.66664,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 622080,
        "time": 26.999973,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 629760,
        "time": 27.333306,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 641280,
        "time": 27.833305499999998,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 645120,
        "time": 27.999972,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 652800,
        "time": 28.333305,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 656640,
        "time": 28.4999715,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 660480,
        "time": 28.666638,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 672000,
        "time": 29.1666375,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 675840,
        "time": 29.333304,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 683520,
        "time": 29.666636999999998,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 691200,
        "time": 29.999969999999998,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 702720,
        "time": 30.4999695,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 706560,
        "time": 30.666636,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 710400,
        "time": 30.8333025,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 714240,
        "time": 30.999969,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 721920,
        "time": 31.333302,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 733440,
        "time": 31.833301499999997,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999903,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 737280,
        "time": 31.999968,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 744960,
        "time": 32.333301,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 752640,
        "time": 32.666634,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 764160,
        "time": 33.166633499999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 768000,
        "time": 33.3333,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 775680,
        "time": 33.666633,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 779520,
        "time": 33.8332995,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 783360,
        "time": 33.999966,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 794880,
        "time": 34.4999655,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 798720,
        "time": 34.666632,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 806400,
        "time": 34.999964999999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 814080,
        "time": 35.333298,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 825600,
        "time": 35.8332975,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 829440,
        "time": 35.999964,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 833280,
        "time": 36.1666305,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 837120,
        "time": 36.333297,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 844800,
        "time": 36.66663,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 856320,
        "time": 37.1666295,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 860160,
        "time": 37.333296,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 867840,
        "time": 37.666629,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 875520,
        "time": 37.999962,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 887040,
        "time": 38.4999615,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 890880,
        "time": 38.666627999999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 898560,
        "time": 38.999961,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 902400,
        "time": 39.1666275,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 906240,
        "time": 39.333294,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 917760,
        "time": 39.833293499999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 921600,
        "time": 39.99996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 929280,
        "time": 40.333293,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 936960,
        "time": 40.666626,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 948480,
        "time": 41.1666255,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 952320,
        "time": 41.333292,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 956160,
        "time": 41.4999585,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 960000,
        "time": 41.666624999999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 967680,
        "time": 41.999958,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 979200,
        "time": 42.4999575,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 983040,
        "time": 42.666624,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 990720,
        "time": 42.999957,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 998400,
        "time": 43.33329,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1009920,
        "time": 43.8332895,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1013760,
        "time": 43.999956,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1021440,
        "time": 44.333289,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1025280,
        "time": 44.4999555,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1029120,
        "time": 44.666622,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1040640,
        "time": 45.1666215,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1044480,
        "time": 45.333287999999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1052160,
        "time": 45.666621,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1059840,
        "time": 45.999953999999995,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1071360,
        "time": 46.4999535,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1075200,
        "time": 46.66662,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1079040,
        "time": 46.8332865,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1082880,
        "time": 46.999953,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1090560,
        "time": 47.333286,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1102080,
        "time": 47.833285499999995,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1105920,
        "time": 47.999952,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1113600,
        "time": 48.333285,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1121280,
        "time": 48.666618,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1132800,
        "time": 49.1666175,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1136640,
        "time": 49.333284,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1144320,
        "time": 49.666616999999995,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1148160,
        "time": 49.8332835,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1152000,
        "time": 49.99995,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1163520,
        "time": 50.4999495,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1167360,
        "time": 50.666616,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1175040,
        "time": 50.999949,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1182720,
        "time": 51.333282,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1194240,
        "time": 51.8332815,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1198080,
        "time": 51.999947999999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1201920,
        "time": 52.1666145,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333324999999547,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1205760,
        "time": 52.333281,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 37,
        "name": "C#2",
        "ticks": 1213440,
        "time": 52.666613999999996,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.08333325000000258,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1224960,
        "time": 53.1666135,
        "velocity": 0.6299212598425197
    }
];

export default cueSet2;